// @TODO: naming convention

// Typed
export const SET_ESSAY_SCORE = "SET_ESSAY_SCORE";

export interface ISetEsssayScore {
  type: typeof SET_ESSAY_SCORE;
  payload: EssayRequest;
}

export const HANDLE_UPDATE_ESSAY_SCORE = "HANDLE_UPDATE_ESSAY_SCORE";

export interface IHandleUpdateEssayScore {
  type: typeof HANDLE_UPDATE_ESSAY_SCORE;
  payload: EssayRequest;
}

export const SET_ACTIVE_TEST_SCORES = "SET_ACTIVE_TEST_SCORES";

export interface ISetActiveTestScores {
  type: typeof SET_ACTIVE_TEST_SCORES;
  payload: TestScores;
}

export const HANDLE_ASSIGN_STUDENT_TEST = "HANDLE_ASSIGN_STUDENT_TEST";

export interface IHandleAssignStudentTest {
  type: typeof HANDLE_ASSIGN_STUDENT_TEST;
  payload: Partial<NewTestRequest>;
  source: Source;
}

export const HANDLE_FETCH_STUDENT_TEST_SECTIONS = "HANDLE_FETCH_STUDENT_TEST_SECTIONS";

export interface IHandleFetchStudentTestSections {
  type: typeof HANDLE_FETCH_STUDENT_TEST_SECTIONS;
  payload: StudentTestSectionPayload;
}

export const HANDLE_FETCH_STUDENT_TEST_REPORT_LINK = "HANDLE_FETCH_STUDENT_TEST_REPORT_LINK";

export interface IHandleFetchStudentTestReportLink {
  type: typeof HANDLE_FETCH_STUDENT_TEST_REPORT_LINK;
  payload: StudentTestReportLinkPayload;
}

export const HANDLE_FETCH_STUDENT_TEST_REPORT = "HANDLE_FETCH_STUDENT_TEST_REPORT";

export interface IHandleFetchStudentTestReport {
  type: typeof HANDLE_FETCH_STUDENT_TEST_REPORT;
  payload: StudentTestReport;
}

export const SET_ACTIVE_STUDENT_TEST = "SET_ACTIVE_STUDENT_TEST";

export interface ISetActiveStudentTest {
  type: typeof SET_ACTIVE_STUDENT_TEST;
  payload: Test;
}

export const SET_STUDENT_TESTS = "SET_STUDENT_TESTS";

export interface ISetStudentTests {
  type: typeof SET_STUDENT_TESTS;
  payload: Test[];
}

export const HANDLE_RESCHEDULE_STUDENT_TEST = "HANDLE_RESCHEDULE_STUDENT_TEST";

export interface IHandleRescheduleStudentTest {
  type: typeof HANDLE_RESCHEDULE_STUDENT_TEST;
  payload: RescheduleStudentTestRequest;
}

export const UPDATE_STUDENT_TEST = "UPDATE_STUDENT_TEST";

export interface IUpdateStudentTest {
  type: typeof UPDATE_STUDENT_TEST;
  payload: UpdateTestPayload;
  testChanges: TestChangesRequest;
}

export const HANDLE_CREATE_STUDENT_REAL_TEST = "HANDLE_CREATE_STUDENT_REAL_TEST";

export interface IHandleCreateStudentRealTest {
  type: typeof HANDLE_CREATE_STUDENT_REAL_TEST;
  payload: StudentRealTestRequest | RealTestEditRequest;
}

export const HANDLE_UPDATE_STUDENT_REAL_TEST = "HANDLE_UPDATE_STUDENT_REAL_TEST";

export interface IHandleUpdateStudentRealTest {
  type: typeof HANDLE_UPDATE_STUDENT_REAL_TEST;
  payload: RealTestEditRequest;
  changes: TestChangesRequest;
}

export const HANDLE_FETCH_STUDENT_TESTS = "HANDLE_FETCH_STUDENT_TESTS";

export interface IHandleFetchStudentTests {
  type: typeof HANDLE_FETCH_STUDENT_TESTS;
}

export const HANDLE_FETCH_ALL_STUDENT_TESTS = "HANDLE_FETCH_ALL_STUDENT_TESTS";

export interface IHandleFetchAllStudentTests {
  type: typeof HANDLE_FETCH_ALL_STUDENT_TESTS;
}

export const HANDLE_RESET_STUDENT_TESTS = "HANDLE_RESET_STUDENT_TESTS";

export interface IHandleResetStudentTest {
  type: typeof HANDLE_RESET_STUDENT_TESTS;
  payload: string[];
}

export const HANDLE_STUDENT_TEST_SECTION_MANAGEMENT = "HANDLE_STUDENT_TEST_SECTION_MANAGEMENT";

export interface IHandleStudentTestSectionManagement {
  type: typeof HANDLE_STUDENT_TEST_SECTION_MANAGEMENT;
  payload: TestSectionPayload;
}

export const HANDLE_EXCUSE_STUDENT_TEST_LATENESS = "HANDLE_EXCUSE_STUDENT_TEST_LATENESS";

export interface IHandleExcuseStudentTestLateness {
  type: typeof HANDLE_EXCUSE_STUDENT_TEST_LATENESS;
  payload: UpdateTestLatenessObject[];
}

export const HANDLE_MARK_TEST_ALL_FLAGS_REVIEWED = "HANDLE_MARK_TEST_ALL_FLAGS_REVIEWED";

export interface IHandleMarkTestAllFlagsReviewed {
  type: typeof HANDLE_MARK_TEST_ALL_FLAGS_REVIEWED;
  payload: any;
  /* PAYLOAD NEED TO BE CHECKED WITH SWAGGER */
}

export const SET_STUDENT_TEST_SECTIONS = "SET_STUDENT_TEST_SECTIONS";

export interface ISetStudentTestSections {
  type: typeof SET_STUDENT_TEST_SECTIONS;
  payload: Section[];
}

export const SET_STUDENT_TEST_REPORT_LINK = "SET_STUDENT_TEST_REPORT_LINK";

export interface ISetStudentTestReportLink {
  type: typeof SET_STUDENT_TEST_REPORT_LINK;
  payload: StudentTestReportLink;
}

export const SET_STUDENT_TEST_REPORT_DATA = "SET_STUDENT_TEST_REPORT_DATA";

export interface ISetStudentTestReportData {
  type: typeof SET_STUDENT_TEST_REPORT_DATA;
  payload: StudentTestReportData;
}

// TEST FLAGS
export const HANDLE_UPDATE_STUDENT_TEST_PROBLEM_FLAG_STATUS =
  "HANDLE_UPDATE_STUDENT_TEST_PROBLEM_FLAG_STATUS";

export interface IHandleUpdateStudentTestProblemFlagStatus {
  type: typeof HANDLE_UPDATE_STUDENT_TEST_PROBLEM_FLAG_STATUS;
  payload: UpdateStudentTestFlagPayload;
}

export const HANDLE_ADD_STUDENT_TEST_PROBLEM_FLAG = "HANDLE_ADD_STUDENT_TEST_PROBLEM_FLAG";

export interface IHandleAddStudentTestProblemFlag {
  type: typeof HANDLE_ADD_STUDENT_TEST_PROBLEM_FLAG;
  payload: AddStudentTestFlagPayload;
}

export const SET_STUDENT_TEST_PROBLEM_FLAG_STATUS = "SET_STUDENT_TEST_PROBLEM_FLAG_STATUS";

export interface ISetStudentTestProblemFlagStatus {
  type: typeof SET_STUDENT_TEST_PROBLEM_FLAG_STATUS;
  payload: UpdateStudentTestProblemFlagPayload;
}

// UPDATE_TEST_FLAG_COUNT
export const SET_STUDENT_TEST_FLAG_COUNT = "SET_STUDENT_TEST_FLAG_COUNT";

export interface ISetStudentTestFlagCount {
  type: typeof SET_STUDENT_TEST_FLAG_COUNT;
  payload: UpdateStudentTestFlagsCountPayload;
}

export const HANDLE_FETCH_STUDENT_SCORED_TESTS = "HANDLE_FETCH_STUDENT_SCORED_TESTS";

export interface IHandleFetchStudentScoredTests {
  type: typeof HANDLE_FETCH_STUDENT_SCORED_TESTS;
}

export const SET_STUDENT_SCORED_TESTS = "SET_STUDENT_SCORED_TESTS";

export interface ISetStudentScoredTests {
  type: typeof SET_STUDENT_SCORED_TESTS;
  payload: ScoredTest[];
}

export const FETCH_STUDENT_REPORT_PDF = "FETCH_STUDENT_REPORT_PDF";

export interface IHandleFetchPartialStudentTestReportPDF {
  type: typeof FETCH_STUDENT_REPORT_PDF;
  payload: StudentTestReportPDFRequest;
  isPartial?: boolean;
  preview?: boolean;
}

export const SET_STUDENT_TEST_PREVIEW_PDF = "SET_STUDENT_TEST_PREVIEW_PDF";

export interface ISetStudentTestPreviewPDF {
  type: typeof SET_STUDENT_TEST_PREVIEW_PDF;
  payload: Blob;
}

export const HANDLE_FETCH_TRIBYTE_TEST_SECTION = "HANDLE_FETCH_TRIBYTE_TEST_SECTION";

export interface IHandleFEtchTribyteTestSection {
  type: typeof HANDLE_FETCH_TRIBYTE_TEST_SECTION;
  payload: {
    test: Test;
  };
}

export const SET_TRIBYTE_TEST_SECTION_URL = "SET_TRIBYTE_TEST_SECTION_URL";

export interface ISetTribyteTestSectionUrl {
  type: typeof SET_TRIBYTE_TEST_SECTION_URL;
  payload: {
    sectionId: string;
    url: string;
  };
}
